import { serializeCsv } from "./csvParse";

/** CRM opportunity import template — one row per opportunity (single location). */
export const CRM_IMPORT_CSV_TEMPLATE_HEADERS = [
  "company",
  "title",
  "status",
  "work_orders",
  "project_type",
  "new_customer",
  "term",
  "sales_rep",
  "notes",
  "site_contact_name",
  "site_contact_email",
  "site_contact_phone",
  "it_contact_name",
  "it_contact_email",
  "it_contact_phone",
  "departments",
  "service_location",
  "connection_types",
  "subtype",
  "a_location",
  "z_location",
  "service_speed",
  "ips",
  "mrc",
  "nrc",
];

const SAMPLE_ROWS = [
  {
    company: "Acme Manufacturing",
    title: "Acme DIA 1G",
    status: "closed",
    work_orders: "4521",
    project_type: "Revenue",
    new_customer: "false",
    term: "36",
    sales_rep: "rep@example.com",
    notes: "Imported closed deal — link existing WO",
    site_contact_name: "Pat Site",
    site_contact_email: "pat@acme.example",
    site_contact_phone: "555-0100",
    it_contact_name: "Sam IT",
    it_contact_email: "sam@acme.example",
    it_contact_phone: "555-0101",
    departments: "Engineering,Networking,Accounting",
    service_location: "100 Industrial Way, Example City, CA",
    connection_types: "DIA",
    subtype: "",
    a_location: "",
    z_location: "",
    service_speed: "1g",
    ips: "29",
    mrc: "1200",
    nrc: "500",
  },
  {
    company: "Northside Clinic",
    title: "Northside PTP",
    status: "open",
    work_orders: "",
    project_type: "Revenue",
    new_customer: "true",
    term: "24",
    sales_rep: "rep@example.com",
    notes: "Pending sale — no WO yet",
    site_contact_name: "Alex Front Desk",
    site_contact_email: "alex@northside.example",
    site_contact_phone: "555-0200",
    it_contact_name: "",
    it_contact_email: "",
    it_contact_phone: "",
    departments: "Engineering,Construction,Fiber,Networking,Accounting",
    service_location: "Clinic A end",
    connection_types: "PTP",
    subtype: "",
    a_location: "Clinic A, 12 Main St",
    z_location: "Clinic B, 44 Oak Ave",
    service_speed: "",
    ips: "",
    mrc: "800",
    nrc: "2500",
  },
];

export function downloadCrmOpportunityImportCsvTemplate() {
  const csv = serializeCsv(CRM_IMPORT_CSV_TEMPLATE_HEADERS, SAMPLE_ROWS);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "crm-opportunities-import-template.csv";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
